var delayTime = $('.videoSwiper').attr('data-delay')
var videoSwiperState = $('.videoSwiper').attr('data-autoplay');
if(videoSwiperState=="true"){
  var swiperVideo = new Swiper(".videoSwiper .mySwiper", {
    slidesPerView:2,
    spaceBetween: 0,
    centeredSlides:true,
    loop:true,
    autoplay:true,
    pagination: {
    el: ".videoSwiper .swiper-pagination",
    clickable: true,
    },
    on: {
        slideChangeTransitionStart: function(){
          $('video').trigger('pause');
      $('.swiper-slide-active').find('video').trigger('play')
      },
    },
    autoplay:{
      delay:delayTime*1000,
    disableOnInteraction: false,
    },
    breakpoints: {
      320: {
      slidesPerView: 1,
      spaceBetween: 0,
      },
      768: {
      slidesPerView: 1.6,
      spaceBetween: 0,
      },
      1200: {
      slidesPerView: 2,
      spaceBetween: 0,
      },
    },
  });
  $(".box4_text div:nth-child(2)").click(function() {
    swiperVideo.autoplay.stop();
    var element = $(this).parents(".swiperItem").children("video")[0];
    window.innerWidth > 750 ? element.requestFullscreen && element.requestFullscreen() : $(this).parents(".box4_item").find(".box4_mask").hide(), 
    
    element.addEventListener("ended", function() {
      element.exitFullscreen ? element.exitFullscreen() : element.webkitExitFullscreen ? element.webkitExitFullscreen() : element.mozCancelFullScreen ? element.mozCancelFullScreen() : element.msExitFullscreen && element.msExitFullscreen(), element.currentTime = 0
      swiperVideo.autoplay.start();
    })
  });
}else{
  $(".box4_text div:nth-child(2)").click(function() {
    var element = $(this).parents(".swiperItem").children("video")[0];
    swiperVideo.autoplay.stop();
    window.innerWidth > 750 ? element.requestFullscreen && element.requestFullscreen() : $(this).parents(".box4_item").find(".box4_mask").hide(), 
    element.addEventListener("ended", function() {
      element.exitFullscreen ? element.exitFullscreen() : element.webkitExitFullscreen ? element.webkitExitFullscreen() : element.mozCancelFullScreen ? element.mozCancelFullScreen() : element.msExitFullscreen && element.msExitFullscreen(), element.currentTime = 0
      swiperVideo.autoplay.start();
    })
  });
  var swiperVideo = new Swiper(".videoSwiper .mySwiper", {
    slidesPerView:2,
    spaceBetween: 0,
    centeredSlides:true,
    loop:true,
    autoplay:false,
    pagination: {
    el: ".videoSwiper .swiper-pagination",
    clickable: true,
    },
    on: {
        slideChangeTransitionStart: function(){
          $('video').trigger('pause');
      $('.swiper-slide-active').find('video').trigger('play')
      },
    },
    breakpoints: {
      320: {
      slidesPerView: 1,
      spaceBetween: 0,
      },
      768: {
      slidesPerView: 1.6,
      spaceBetween: 0,
      },
      1200: {
      slidesPerView: 2,
      spaceBetween: 0,
      },
    },
  });
}

$(function(){
  var screenWidth = $(window).width();
  if(screenWidth>780){
    
  }else{
    $('.videoSwiper video').attr('controls','controls')
  }
  $('.videoSwiper video').trigger('pause');
  $('.videoSwiper .swiper-slide-active').find('video').trigger('play')
})